import React from 'react';

const Card = ({ 
  children, 
  className = '',
  padding = 'default',
  hover = false,
  ...props 
}) => {
  const paddings = {
    none: '',
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8'
  };
  
  const baseClasses = `bg-gradient-to-b from-[#1f2937] to-[#111827] rounded-xl border border-gray-700/50 shadow-xl ${paddings[padding]} ${hover ? 'hover:border-gray-600/50 transition-colors' : ''} ${className}`;
  
  return (
    <div className={baseClasses} {...props}>
      {children}
    </div>
  );
};

export default Card;
